<!-- ProgressBar.vue -->
<template>
  <div class="relative w-full h-3 mt-2">
    <!-- Gray background with rounded corners -->
    <div class="absolute inset-0 bg-gray-200 rounded-xl"></div>

    <!-- Progress fill -->
    <div
      class="absolute right-0 top-0 h-full bg-[#ffd68f] transition-all duration-500 ease-in-out rounded-r-xl"
      :style="{ width: `${progress}%` }"
    >
      <!-- Checkmark -->
      <div
        v-if="showCheckmark && progress > 0"
        class="absolute -left-2 -top-[5px] z-10 flex items-center justify-center p-[2px] bg-[#ffab1a] rounded-full w-5 h-5"
      >
        <i class="pi pi-check text-white" style="font-size: 0.6rem"/>
      </div>
    </div>

    <!-- Progress segments -->
    <div class="absolute top-0 right-0 w-full h-full flex overflow-hidden">
      <div v-for="n in segments" :key="n" class="flex-1 border-l border-white last:border-l-0"></div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  progress: {
    type: Number,
    default: 0,
    validator: (value) => value >= 0 && value <= 100
  },
  segments: {
    type: Number,
    default: 4
  },
  showCheckmark: {
    type: Boolean,
    default: true
  }
})
</script>
